import "./header.scss";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setStatus } from "../../redux/slices/statusSlice";
import { usePingQuery, useSingInMutation } from "../../redux/services/velmartAPI";
import { menuListNames } from "../../data/menuList";

import signOutIcon from "../../images/header-icons/sign-out-icon.svg";

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const [singOut, { error }] = useSingInMutation();
    const { data: ping, refetch: refetchPing } = usePingQuery("");

    const getLocationName = () => {
        return menuListNames.find((menuItem) => {
            if (menuItem.link === location?.pathname) {
                return true;
            }
        })?.name;
    };

    useEffect(() => {
        if (ping?.user === null) {
            localStorage.setItem("isLoged", JSON.stringify(false));
            navigate("/");
        }
    }, [ping]);

    const logOutHandler = async () => {
        try {
            await singOut({ url: "sign-out" }).unwrap();
        } catch (e) {
            console.log(e);
        }
        localStorage.setItem("isLoged", JSON.stringify(false));
        dispatch(setStatus(false));
        await refetchPing();
        navigate("/");
    };

    // console.log(location.pathname.split("/"));

    return (
        <div className="header">
            <div className="header__title">{getLocationName()}</div>
            <div className="header__info">
                <div className="header__info-user">
                    <img
                        className="header__info-user-img"
                        src={require("../../images/user-logos/user-logo-icon.png")}
                    />

                    <div className="header__info-user-name">Владислав Мельник</div>
                </div>
                <div className="header__info-sign-out-button">
                    <img src={signOutIcon} alt="sign-out" className="header__info-sign-out-button-icon" />
                    <div className="s"></div>
                    <div className="header__info-sign-out-button-title" onClick={() => logOutHandler()}>
                        Вийти
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;
